import { createSlice } from '@reduxjs/toolkit';

// POM-6405 — Inventory → Manufacturer Management.
// filter.status: 'ACTIVE' (default) = not removed, 'INACTIVE' = removed, undefined = all.
export const DEFAULT_MANUFACTURER_FILTER = {
  manufacturer: undefined,
  status: 'ACTIVE',
};

const initialState = {
  currentPage: 1,
  pages: {},
  totalCount: 0,
  sort: 'MANUFACTURER_ASC',
  filter: DEFAULT_MANUFACTURER_FILTER,
};

/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const manufacturerManagementSlice = createSlice({
  name: 'manufacturerManagement',
  initialState,
  reducers: {
    loadManufacturers(state, action) {
      const { page, items, totalCount } = action.payload;
      state.pages[page] = items;
      state.totalCount = totalCount;
    },
    updateCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    updateFilter(state, action) {
      state.pages = {};
      state.totalCount = 0;
      state.filter = action.payload;
    },
    setSort(state, action) {
      state.pages = {};
      state.totalCount = 0;
      state.sort = action.payload;
    },
    resetPages(state) {
      state.pages = {};
    },
  },
});

export const manufacturerManagementActions = manufacturerManagementSlice.actions;
export default manufacturerManagementSlice.reducer;
